import { TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { DateUtil } from "@mcleod/core";
import { AutogenLayoutMobileCommPerformanceDataList } from "./autogen/AutogenLayoutMobileCommPerformanceDataList";

export class MobileCommPerformanceDataList extends AutogenLayoutMobileCommPerformanceDataList {
    /**
     * Handles the display formatting for each row in the performance data table.
     * Formats the report date by combining start_date and end_date fields.
     * @param event The table row display event containing row data
     */
    tableMCPerformanceDataOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxMCPerformanceDataReportDate = tableRow.findComponentById("textboxMCPerformanceDataReportDate") as Textbox;

        if (textboxMCPerformanceDataReportDate != null) {
            let startDate = tableRow.data.getDateTime("start_date");
            let endDate = tableRow.data.getDateTime("end_date");
            if (startDate != null) {
                startDate = DateUtil.formatDateTime(startDate, DateUtil.getUserDateTimeFormat());
            }
            if (endDate != null) {
                endDate = DateUtil.formatDateTime(endDate, DateUtil.getUserDateTimeFormat());
            }

            if (startDate && endDate) {
                textboxMCPerformanceDataReportDate.text = `${startDate} - ${endDate}`;
            } else {
                textboxMCPerformanceDataReportDate.text = startDate || endDate || "";
            }
        }
    }
}
